import React, { useState, useEffect } from 'react'
//import { useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'

import { Panel, Table, IconButton, Icon, Form, Button, Message, Modal } from 'rsuite'
import { useForm } from 'react-hook-form'
import { isEmpty } from 'lodash-es'
import moment from 'moment'
import classNames from 'classnames'
import {
  saveYearAndData,
  saveCost,
  saveDetail,
  deletePeriod,
  getProjectCategoryCostCheck,
} from '../../../redux/actions/paymentSave'
import { startLoading, doneLoading } from '../../../utils/loading'
import ConfirmWidget from '../../confirm/ConfirmWidget'
import notification from '../../../utils/notification'
import EditYearCell from '../../../components/cell/EditYearCell'
import EditDateCell from '../../../components/cell/EditDateCell'
import EditNumberCell from '../../../components/cell/EditNumberCell'
import EditEditorCell from '../../../components/cell/EditEditorCell'
import {
  totalData,
  getExpandedId,
  convertTableData,
  initialNewData,
  getTotalSummary,
  getNewDataEditYearAndDate,
  getNewCostDataEditState,
  getNewDetailDataEditState,
} from './PeriodExpensesUtils'
import { dateAndYearValidation } from './Validation'
import './styles.less'
import { budgetFormat } from '../../../utils/formatterUtil'
import { updateWithdrawRequestBudget } from '../../../redux/actions/withdrawRequest'
import { DELETE_ERR_MSG, SAVE_ERR_MSG } from '../../../constants/msgText'
import AlertWidget from '../../confirm/AlertWidget'

const { Column, HeaderCell, Cell } = Table

export default function PeriodExpenses({
  header,
  data,
  initialData,
  initialInstallment,
  isEditable,
  isCollapseAllTableRow,
  onChangeBudget,
  projectVersionId,
  startProjectDate,
  endProjectDate,
  isMulti,
  onMultiSave = () => {},
  isAssociate,
  isEditWithdrawBudget,
  onChangeWithdrawBudget,
  isWithdraw,
  requestId,
  extendPreiod,
}) {
  const { register, handleSubmit, errors, control, setError, clearErrors, setValue } = useForm()
  const [isLoading, setIsLoading] = useState(false)
  const [tableData, setTableData] = useState()
  const [expandedRowKeys, setExpandedRowKeys] = useState([])
  const [isShowConfirmDelete, setIsShowConfirmDelete] = useState(false)
  const [requestDeleteData, setRequestDeleteData] = useState()
  const [isMultiSaveError, setIsMultiSaveError] = useState(false)
  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const [msgErrorChecked, setMsgErrorChecked] = useState(null)
  const [isShowModalChecked, setIsShowModalChecked] = useState(false)

  const projectId = sessionStorage.getItem('projectId')

  useEffect(() => {
    if (isEmpty(data)) {
      return
    }
    const newData = convertTableData(data, isEditable, initialData)
    //     console.log('newData', newData)
    // console.log('totalData', totalData)
    setTableData([...newData, totalData])
    if (!isCollapseAllTableRow) {
      setExpandedRowKeys(getExpandedId(newData))
    }
  }, [data, isCollapseAllTableRow, isEditable])

  const showSaveError = (key, text) => {
    setError(key, {
      type: 'manual',
      message: text,
    })
    notification.open('error', {
      key: key,
      title: text,
      duration: 10000,
    })
  }

  const handleOnClickAddNewData = () => {
    let dataWithoutTotal = []
    if (!isEmpty(tableData)) {
      dataWithoutTotal = tableData.slice(0, -1)
    }
    const addedData = initialNewData(initialData, initialInstallment, dataWithoutTotal)
    console.log('addedData', addedData)
    setTableData((state) => {
      if (state) {
        const dataWithoutTotal = state.slice(0, -1)
        return [...dataWithoutTotal, addedData, totalData]
      }
      return [addedData, totalData]
    })
    const newIds = getExpandedId([addedData])
    setExpandedRowKeys((state) => [...state, ...newIds])
  }

  const handleEditState = (rowData, value, isEditValue = false, _onChangeBudget = () => {}) => {
    //    console.log('handleEditState')

    if (rowData.isDetail) {
      const nextData = getNewDetailDataEditState(tableData, rowData, value, isEditValue)
      setTableData(nextData)
      isEditValue && onChangeWithdrawBudget(nextData)
      return
    }

    const nextData = getNewCostDataEditState(tableData, rowData, value, isEditValue)
    setTableData(nextData)
    isEditValue && onChangeWithdrawBudget(nextData)
    !isWithdraw &&
      _onChangeBudget(getTotalSummary(nextData), nextData.slice(0, nextData.length - 1)) //no callback only Withdraw page
  }

  const handleEditYearAndDate = (
    rowData,
    year,
    date,
    startDate,
    endDate,
    isEditValue = false,
    _onChangeBudget = () => {}
  ) => {
    const nextData = getNewDataEditYearAndDate(
      tableData,
      rowData,
      year,
      date,
      startDate,
      endDate,
      null,
      isEditValue
    )
    isEditValue && onChangeWithdrawBudget(nextData)
    setTableData(nextData)
    _onChangeBudget(getTotalSummary(nextData), nextData.slice(0, nextData.length - 1))
  }

  const handleCallApiSaveCost = async (request, rowData, data) => {
    startLoading()
    try {
      let isComps = true
      //      console.log('isEditWithdrawBudget => ', isEditWithdrawBudget)
      //      console.log('isWithdraw => ', !isWithdraw)
      if (!isMulti && !isEditWithdrawBudget && !isWithdraw) {
        console.log('func A')
        const _schema = await saveCost(request, projectVersionId || projectId)

        if (_schema?.model?.statusCode == 400) {
          setMsgErrorChecked(_schema?.model?.message || '')
          setIsShowModalChecked(true)
          isComps = false
        }
      }

      if (isComps) {
        console.log('func B')

        // if (isEditWithdrawBudget) {
        //   console.log('func C')
        //   const cheked = await handleProjectCategoryCostCheck(request)

        //   if (!cheked) {
        //     doneLoading()
        //     return false
        //   }
        // }

        if (isWithdraw) {
          console.log('func D')
          const response = await updateWithdrawRequestBudget(
            projectVersionId || projectId,
            requestId,
            request
          )
        }

        handleEditState(
          rowData,
          [data[`vat_${rowData.id}`], data[rowData.id]],
          true,
          onChangeBudget
        )
      }
    } catch (e) {
      notification.open('error', {
        title: e?.response?.data?.errorMessage || SAVE_ERR_MSG,
        duration: 10000,
      })
    }
    doneLoading()
  }

  const handleCallApiSaveDetail = async (request, rowData, data) => {
    startLoading()
    try {
      if (!isMulti && !isEditWithdrawBudget) {
        const _schema = await saveDetail(
          request,
          projectVersionId || projectId,
          rowData._parent?._parent?.id
        )
      }
      handleEditState(rowData, data[rowData.id], true)
    } catch (e) {
      notification.open('error', {
        title: e?.response?.data?.errorMessage || SAVE_ERR_MSG,
        duration: 10000,
      })
    }
    doneLoading()
  }

  const handleSave = (data, rowData) => {
    console.log('handleSave', data)

    if (isWithdraw) {
      console.log('step 1')
      //      console.log(rowData)
      const request = {
        id: rowData.id,
        planDetailId: rowData._parent.id,
        budget: data[rowData.id] || 0,
        // vat: data[`vat_${rowData.id}`] || 0,
        // tax: rowData.tax,
      }
      handleCallApiSaveCost(request, rowData, data)
      return
    }

    if (rowData.isDetail) {
      console.log('step 2')
      const request = {
        detail: data[rowData.id],
      }
      handleCallApiSaveDetail(request, rowData, data)
    } else {
      console.log('step 3')

      if (data[`vat_${rowData.id}`] > data[rowData.id]) {
        setMsgErrorChecked(
          `ไม่สามารถทำรายการได้ เนื่องจาก <u><b>VAT</b></u> <b style="color: #fb8a81"}>มีค่ามากกว่า</b> <u><b>จำนวนเงิน+VAT</b></u> `
        )
        setIsShowModalChecked(true)
        return false
      }

      const request = {
        categoryOfCostId: rowData._parent.id,
        categoryCostId: rowData.id,
        cost: data[rowData.id],
        vat: data[`vat_${rowData.id}`] || 0,
        tax: rowData.tax,
      }

      handleCallApiSaveCost(request, rowData, data)
    }
  }

  const handleCallApiSaveYearAndDate = async (request, rowData, year, date, startDate, endDate) => {
    startLoading()
    try {
      if (!isMulti && !isEditWithdrawBudget) {
        const _schema = await saveYearAndData(request, projectVersionId || projectId)
      }
      handleEditYearAndDate(rowData, year, date, startDate, endDate, true, onChangeBudget)
      const isNewInstallment = !rowData.year || !rowData.date
      if (isNewInstallment && rowData.children) {
        rowData.children.forEach((childRowData) => {
          handleEditState(childRowData)
        })
      }
    } catch (e) {
      notification.open('error', {
        title: e?.response?.data?.errorMessage || SAVE_ERR_MSG,
        duration: 10000,
      })
    }
    doneLoading()
  }

  const handleSaveYearAndDate = (data, rowData) => {
    const year = data[`year_${rowData.id}`]
    const date = data[`date_${rowData.id}`]
    const startDate = data[`startDate_${rowData.id}`]
    const endDate = data[`endDate_${rowData.id}`]

    const isInvalid = dateAndYearValidation(
      showSaveError,
      tableData,
      rowData,
      year,
      date,
      startDate,
      endDate,
      startProjectDate,
      endProjectDate
    )
    if (isInvalid) return

    var defaultYear = new Date().getFullYear() + 543
    if (new Date().getMonth() >= 9) {
      defaultYear = new Date().getFullYear() + 543 + 1 //ปีงบประมาณ = ปีปัจุบัน+1 (เดือน 10 11 12)
    }

    const request = {
      categoryOfCostId: rowData.id,
      numberOfInstallment: rowData.numberOfInstallment,
      date: moment(date).format('DD/MM/YYYY'),
      startDate: moment(startDate).format('DD/MM/YYYY'),
      endDate: moment(endDate).format('DD/MM/YYYY'),
      budgetYear: defaultYear, //year,
    }

    handleCallApiSaveYearAndDate(request, rowData, defaultYear, date, startDate, endDate)
  }

  const handleCallApiDeleteCost = async (rowData) => {
    startLoading()
    try {
      if (!isMulti && !isEditWithdrawBudget) {
        const _schema = await deletePeriod(projectVersionId || projectId, rowData.id)
      }
      const removedData = [...tableData.slice(0, -2)]
      onChangeBudget(getTotalSummary(removedData), removedData)
      setTableData([...removedData, totalData])
    } catch (e) {
      notification.open('error', {
        title: e?.response?.data?.errorMessage || DELETE_ERR_MSG,
        duration: 10000,
      })
    }
    doneLoading()
  }

  const handleDelete = (rowData) => {
    if (!rowData.year || !rowData.date) {
      return setTableData((state) => [...state.slice(0, -2), totalData])
    }
    setIsShowConfirmDelete(true)
    setRequestDeleteData(rowData)
  }

  const handleOnConfirmDelete = () => {
    setIsShowConfirmDelete(false)
    handleCallApiDeleteCost(requestDeleteData)
  }

  const handleProjectCategoryCostCheck = async (request) => {
    console.log('handleProjectCategoryCostCheck => ', projectId)
    startLoading()
    let returnVal = false

    if (!projectId) {
      doneLoading()
      console.log('project Id is null.')
      return false
    }

    try {
      const response = await getProjectCategoryCostCheck(projectId, request)
      console.log('response => ', response)

      if (response?.success) {
        if (response?.model?.info?.length > 0) {
          let msg = ''
          response?.model?.info.map((item, index) => {
            msg += `${index + 1}). ${item.checkCategoryCostMessage} <br />`
          })

          setMsgErrorChecked(msg)
          setIsShowModalChecked(true)
        } else {
          returnVal = true
        }
      } else {
        notification.open('error', {
          title: response?.message || SAVE_ERR_MSG,
          duration: 10000,
        })
      }
    } catch (e) {
      console.log('error => ', e)
      notification.open('error', {
        title: e?.response?.data?.errorMessage || SAVE_ERR_MSG,
        duration: 10000,
      })
    }

    doneLoading()

    return returnVal
  }

  const renderSaveButtonGroup = (rowData, _handleSave, _handleEdit) => {
    return (
      <>
        <IconButton
          appearance="ghost"
          icon={<Icon icon={isMulti ? 'check' : 'save'} className="bt-gost-icon-radius" />}
          onClick={handleSubmit(async (data) => {
            _handleSave(data, rowData)
          })}
        >
          {isMulti ? 'ยืนยัน' : 'บันทึก'}
        </IconButton>
        <IconButton
          appearance="ghost"
          className="rs-btn-ghost-cancel"
          style={{ marginLeft: 5 }}
          icon={<Icon icon="close" className="bt-gost-icon-radius-cancel" />}
          onClick={() => {
            _handleEdit(rowData)
          }}
        >
          ยกเลิก
        </IconButton>
      </>
    )
  }

  const handleMultiSave = () => {
    let isError
    let errorText = 'กรุณายันยันรายการที่แก้ไขค้างไว้ก่อน'

    tableData.forEach((element) => {
      if (element.status == 'EDIT') {
        notification.open('error', {
          title: errorText,
          duration: 10000,
        })
        isError = true
        return
      } else {
        element?.children?.forEach((subElement) => {
          if (subElement.status == 'EDIT') {
            notification.open('error', {
              title: errorText,
              duration: 10000,
            })
            isError = true
            return
          } else {
            subElement?.children?.forEach((sub2Element) => {
              if (sub2Element.status == 'EDIT') {
                notification.open('error', {
                  title: errorText,
                  duration: 10000,
                })
                isError = true
                return
              }
            })
          }
        })
      }
    })

    if (!isError) {
      onMultiSave(tableData)
    }
  }

  const findDefaultDate = (rowData, tableData, isStartDate) => {
    //ใช้สำหรับ set วันที่เริ่มต้นของงวด
    var date
    if (rowData.startDate) {
      //กรณีเคยกรอกไปแล้ว ใช้วันที่เคยกรอกไว้
      date = moment(rowData.startDate, 'DD/MM/YYYY').toDate()
    } else {
      //กรณีไม่เคยกรอกเคยกรอก ไปดึงวันที่สิ้นสุดงวด ของงวดก่อนหน้า
      let previousInstallmentDate
      tableData?.length > 0 &&
        tableData.forEach((item, index) => {
          //ลูป หาวันที่จากงวดก่อนหน้า
          if (item.id === rowData.id) {
            let _index = isStartDate ? index - 1 : index + 1
            if (isStartDate && tableData[_index]?.endDate) {
              //กรณีหาวันที่เรื่มงวด และมีงวดก่อนหน้า นำวันที่สิ้นสุด+1 มาเป็น default ให้
              previousInstallmentDate = moment(tableData[_index].endDate, 'DD/MM/YYYY').toDate() //convert date
              previousInstallmentDate.setUTCDate(previousInstallmentDate.getUTCDate() + 1) //set date +1
            } else {
              previousInstallmentDate = false
            }
          }
        })
      if (!previousInstallmentDate) {
        //กรณีไม่เจอข้อมูลงวดก่อนหรือวันที่สิ้นสุดของวดก่อน(เป็นการเพิ่มงวดที่ 1) ให้ default วันที่เริ่มโครงการ
        previousInstallmentDate = startProjectDate
      }

      date = moment(previousInstallmentDate, 'DD/MM/YYYY').toDate()
    }
    return date
  }

  const findStartDate = (rowData, tableData) => {
    //หาช่วงวันที่ ที่สามารถเลือกได้ (เริ่มต้น)
    var date = startProjectDate //set เป็นวันที่เริ่มโครงการ
    tableData?.length > 0 &&
      tableData.forEach((item, index) => {
        if (item.id === rowData.id && tableData[index - 1]?.endDate) {
          //กรณีมีงวดก่อนหน้า วันที่สามารถเลือกได้คือ วันสิ้นสุดงวดก่อน + 1
          //date = tableData[index-1]?.endDate

          date = moment(tableData[index - 1]?.endDate, 'DD/MM/YYYY').toDate() //convert date
          date.setUTCDate(date.getUTCDate() + 1) //set date +1
        }
      })
    return date
  }

  const findEndDate = (rowData, tableData) => {
    //หาช่วงวันที่ ที่สามารถเลือกได้ (สิ้นสุด)
    var date = endProjectDate //set เป็นวันที่สิ้นสุดโครงการ
    tableData?.length > 0 &&
      tableData.forEach((item, index) => {
        if (item.id === rowData.id && tableData[index + 1]?.startDate) {
          date = tableData[index + 1]?.startDate
        }
      })
    return date
  }

  //  console.log('tableData => ', tableData)

  return (
    <div className="period-expenses">
      <Panel header={header} bordered collapsible defaultExpanded>
        {isWithdraw && isEditable && (
          <Message showIcon type="warning" description={'กรุณาระบุจำนวนเงินที่จะขอเบิกในงวดนี้'} />
        )}
        {tableData && (
          <Form className="form-table">
            <Table
              isTree
              expandedRowKeys={expandedRowKeys}
              onExpandChange={(expanded, rowData) => {
                if (expanded) {
                  setExpandedRowKeys((state) => [...state, rowData.id])
                } else {
                  setExpandedRowKeys((state) => state.filter((item) => item !== rowData.id))
                }
              }}
              rowKey="id"
              autoHeight
              data={tableData}
              shouldUpdateScroll={false}
              rowHeight={(rowData) => (rowData?.isDetail ? 210 : 64)}
              headerHeight={80}
              wordWrap={true}
            >
              <Column width={104} colSpan={6}>
                <HeaderCell>งวดเงิน</HeaderCell>
                <Cell>
                  {(rowData) => {
                    if (rowData._parent?._parent) {
                      return (
                        <EditEditorCell
                          rowData={rowData}
                          dataKey="list"
                          register={register}
                          control={control}
                          errors={errors}
                          clearErrors={clearErrors}
                          setValue={setValue}
                        />
                      )
                    }
                    return (
                      <span className={classNames(rowData.isTotal && 'total-summary')}>
                        {rowData.list}
                      </span>
                    )
                  }}
                </Cell>
              </Column>

              {/* <Column width={132} align="center">
                <HeaderCell>ปีงบประมาณ</HeaderCell>
                <Cell>
                  {(rowData) => {
                    
                    if (!rowData._parent && !rowData.isTotal) {
                      //console.log('rowData', rowData)
                      return (
                        <EditYearCell
                          id={`year_${rowData.id}`}
                          rowData={rowData}
                          dataKey="year"
                          register={register}
                          control={control}
                          errors={errors}
                        />
                      )
                    }
                    return null
                  }}
                </Cell>
              </Column> */}

              <Column width={150} align="center">
                <HeaderCell>วันที่เริ่มงวด</HeaderCell>
                <Cell>
                  {(rowData) => {
                    if (!rowData._parent && rowData.children) {
                      let _startProjectDate = findStartDate(rowData, tableData) //ช่วงวันที่สามารถเลือกได้ (เริ่มต้น)
                      let _endProjectDate = findEndDate(rowData, tableData) //ช่วงวันที่สามารถเลือกได้ (สิ้นสุด)
                      let defaultDate = findDefaultDate(rowData, tableData, true) //default วันที่มาให้ โดยอ้างอิงจากงวดก่อน

                      // console.log('_startProjectDate : ', _startProjectDate)
                      // console.log('_endProjectDate : ', _endProjectDate)
                      // console.log('defaultDate : ', defaultDate)

                      return (
                        <EditDateCell
                          id={`startDate_${rowData.id}`}
                          rowData={rowData}
                          dataKey="startDate"
                          register={register}
                          control={control}
                          errors={errors}
                          startDate={_startProjectDate}
                          endDate={_endProjectDate}
                          defaultDate={defaultDate}
                        />
                      )
                    }
                    return null
                  }}
                </Cell>
              </Column>

              <Column width={150} align="center" colSpan={4}>
                <HeaderCell>วันที่สิ้นสุดงวด</HeaderCell>
                <Cell>
                  {(rowData) => {
                    if (rowData.isDetail) {
                      return null
                    }
                    if (!rowData._parent && rowData.children) {
                      let _startProjectDate = findStartDate(rowData, tableData) //ช่วงวันที่สามารถเลือกได้ (เริ่มต้น)
                      let _endProjectDate = findEndDate(rowData, tableData) //ช่วงวันที่สามารถเลือกได้ (สิ้นสุด)
                      let defaultDate //default วันที่มาให้
                      if (rowData.endDate) {
                        //กรณีเคยกรอกไปแล้ว ใช้วันที่เคยกรอกไว้
                        defaultDate = moment(rowData.endDate, 'DD/MM/YYYY').toDate()
                      } else {
                        //กรณีไม่เคยกรอกจะไปเอาวันสิ้นสุดโครงการมา
                        defaultDate = moment(_endProjectDate, 'DD/MM/YYYY').toDate()
                      }
                      return (
                        <div style={{ width: 130 }}>
                          <EditDateCell
                            id={`endDate_${rowData.id}`}
                            rowData={rowData}
                            dataKey="endDate"
                            register={register}
                            control={control}
                            errors={errors}
                            startDate={_startProjectDate}
                            endDate={_endProjectDate}
                            defaultDate={defaultDate}
                          />
                        </div>
                      )
                    }
                    return <span className="column--lable">{rowData.label}</span>
                  }}
                </Cell>
              </Column>

              <Column width={162} align="center">
                <HeaderCell>กำหนดส่งผลงาน</HeaderCell>
                <Cell>
                  {(rowData) => {
                    if (!rowData._parent) {
                      let _startProjectDate = findStartDate(rowData, tableData) //ช่วงวันที่สามารถเลือกได้ (เริ่มต้น)
                      let _endProjectDate = findEndDate(rowData, tableData) //ช่วงวันที่สามารถเลือกได้ (สิ้นสุด)
                      let defaultDate
                      if (rowData.date) {
                        //กรณีเคยกรอกไปแล้ว ใช้วันที่เคยกรอกไว้
                        defaultDate = moment(rowData.date, 'DD/MM/YYYY').toDate()
                      } else {
                        //กรณีไม่เคยกรอกจะไปเอาวันสิ้นสุดโครงการมา
                        defaultDate = moment(_endProjectDate, 'DD/MM/YYYY').toDate()
                      }
                      return (
                        <EditDateCell
                          id={`date_${rowData.id}`}
                          rowData={rowData}
                          dataKey="date"
                          register={register}
                          control={control}
                          errors={errors}
                          startDate={_startProjectDate}
                          endDate={_endProjectDate}
                          defaultDate={defaultDate}
                        />
                      )
                    }
                    return null
                  }}
                </Cell>
              </Column>

              {/* <Column minWidth={230} flexGrow={1}>
                  <HeaderCell>รายละเอียดค่าใช้จ่าย</HeaderCell>
                  <Cell dataKey="label" />
                </Column> */}

              <Column width={169} minWidth={120} flexGrow={1} align="right">
                <HeaderCell>จำนวนเงิน+VAT (บาท)</HeaderCell>
                <Cell>
                  {(rowData) => {
                    if ((rowData.children && rowData.children[0].isDetail) || rowData.isDetail) {
                      return
                    } else if (rowData.isTotal) {
                      return (
                        <span className={'cost-total-summary'}>
                          {`${budgetFormat(getTotalSummary(tableData))}`}
                        </span>
                      )
                    } else if (!rowData._parent && rowData.children) {
                      return <span className={'cost-summary'}>{budgetFormat(rowData.cost)}</span>
                    }

                    return (
                      <EditNumberCell
                        rowData={rowData}
                        dataKey="cost"
                        //                        dataKey={`cost_${rowData.id}`}
                        register={register}
                        control={control}
                        errors={errors}
                        isBudgetFormat={true}
                      />
                    )
                  }}
                </Cell>
              </Column>

              <Column width={100} align="right">
                <HeaderCell>VAT</HeaderCell>
                <Cell>
                  {(rowData) => {
                    if (rowData?.children?.length == 1 || rowData?._parent?.children?.length == 1) {
                      return
                    }

                    if (rowData.enableVat) {
                      return (
                        <EditNumberCell
                          id={`vat_${rowData.id}`}
                          rowData={rowData}
                          dataKey="vat"
                          //                          dataKey={`vat_${rowData.id}`}
                          register={register}
                          control={control}
                          errors={errors}
                          isRequired={false}
                          isBudgetFormat={true}
                        />
                      )
                    }

                    return <span>{budgetFormat(rowData.vat || 0)}</span>

                    // if (
                    //   (rowData.children && rowData.children[0].isDetail) ||
                    //   rowData.isDetail ||
                    //   !rowData._parent?._parent
                    // ) {
                    //   return
                    // }
                    // return <span>{`${rowData.vat} %`}</span>
                  }}
                </Cell>
              </Column>

              <Column width={150} align="right">
                <HeaderCell>ภาษี ณ ที่จ่าย (บาท)</HeaderCell>
                <Cell>
                  {(rowData) => {
                    if (rowData?.children?.length == 1 || rowData?._parent?.children?.length == 1) {
                      return
                    }

                    if (rowData._parent) {
                      return <span>{budgetFormat(rowData.withholdingTax || 0)}</span>
                    }

                    // console.log('rowData', rowData)
                    // if (
                    //   (rowData.children && rowData.children[0].isDetail) ||
                    //   rowData.isDetail ||
                    //   !rowData._parent?._parent
                    // ) {
                    //   return
                    // }
                    // return <span>{`${rowData.tax} %`}</span>
                  }}
                </Cell>
              </Column>

              {!isAssociate && (
                <Column width={109} align="center">
                  <HeaderCell>e-budget</HeaderCell>
                  <Cell>
                    {(rowData) => {
                      if (rowData.isTotal || rowData._parent) {
                        return null
                      }
                      const iconName =
                        rowData.isEBudget === true ? 'check-circle' : 'exclamation-triangle'
                      const iconClass = rowData.isEBudget === true ? 'pass' : 'warning'
                      return (
                        <span className={classNames('e-budget', iconClass)}>
                          {rowData.isEBudget != null && <Icon size={'lg'} icon={iconName} />}
                        </span>
                      )
                    }}
                  </Cell>
                </Column>
              )}

              {isEditable && (
                <Column width={235} align="center" fixed="right">
                  <HeaderCell>แก้ไข</HeaderCell>
                  <Cell>
                    {(rowData) => {
                      if (rowData.isTotal) {
                        return null
                      }
                      if (rowData._parent && !rowData.children) {
                        if (rowData.status === 'EDIT') {
                          return renderSaveButtonGroup(rowData, handleSave, handleEditState)
                        } else {
                          const parent = rowData.isDetail
                            ? rowData._parent._parent
                            : rowData._parent
                          if (rowData.isDetail && isWithdraw) {
                            //check if withdraw page hide edit detail
                            return null
                          } else {
                            return (
                              <IconButton
                                appearance="ghost"
                                className="rs-btn-ghost-edit"
                                icon={<Icon icon="edit" className="bt-gost-icon-radius-edit" />}
                                onClick={() => {
                                  handleEditState(rowData)
                                }}
                                disabled={!parent.date || !parent.year || parent.disabled}
                              >
                                แก้ไข
                              </IconButton>
                            )
                          }
                        }
                      } else if (!rowData._parent) {
                        if (rowData.status === 'EDIT') {
                          return renderSaveButtonGroup(
                            rowData,
                            handleSaveYearAndDate,
                            handleEditYearAndDate
                          )
                        } else if (!isWithdraw) {
                          //check if withdraw page hide edit Year and Date
                          var disabledEdit = rowData.disabled

                          if (disabledEdit && extendPreiod) {
                            const match = rowData.list.match(/\d+/)
                            const period = match ? parseInt(match[0], 10) : 0
                            //console.log('list : ', rowData.list, ' , period :', period)

                            var changePreiod = extendPreiod?.find((e) => e.period == period)
                            //console.log('changePreiod : ', changePreiod)

                            if (changePreiod?.isChange) {
                              disabledEdit = false
                            }
                          }

                          return (
                            <>
                              <IconButton
                                appearance="ghost"
                                className="rs-btn-ghost-edit"
                                icon={<Icon icon="edit" className="bt-gost-icon-radius-edit" />}
                                onClick={() => handleEditYearAndDate(rowData)}
                                disabled={disabledEdit}
                              >
                                แก้ไข
                              </IconButton>
                              {rowData.id === tableData[tableData.length - 2].id && (
                                <IconButton
                                  appearance="ghost"
                                  className="rs-btn-ghost-cancel"
                                  style={{ marginLeft: 5 }}
                                  icon={
                                    <Icon icon="trash-o" className="bt-gost-icon-radius-cancel" />
                                  }
                                  onClick={() => handleDelete(rowData)}
                                  disabled={rowData.disabled}
                                >
                                  ลบ
                                </IconButton>
                              )}
                            </>
                          )
                        }
                      }
                      return null
                    }}
                  </Cell>
                </Column>
              )}
            </Table>
          </Form>
        )}

        {isEditable && !isWithdraw && (
          <>
            <br />
            <IconButton
              appearance="ghost"
              icon={<Icon icon="plus" className="bt-gost-icon-radius" />}
              onClick={handleOnClickAddNewData}
              disabled={
                !isEmpty(tableData) && tableData.length > 1 && !tableData[tableData.length - 2].year
              }
            >
              {'เพิ่มงวดเงิน'}
            </IconButton>
          </>
        )}

        {isMulti && (
          <>
            <hr />
            <Button appearance="ghost" onClick={handleMultiSave}>
              {'บันทึกงวดเงินไปยังทุกโครงการ'}
            </Button>
          </>
        )}
      </Panel>
      <ConfirmWidget
        title={`ยืนยันการลบงวดเงิน`}
        show={isShowConfirmDelete}
        detail={`กรุณายืนยันการลบงวดเงิน`}
        onCancle={() => setIsShowConfirmDelete(false)}
        onConfirm={handleOnConfirmDelete}
      />

      <AlertWidget
        size="sm"
        title={'ข้อความแจ้งเตือน !'}
        show={isShowModalChecked}
        detail={
          <div
            dangerouslySetInnerHTML={{
              __html: msgErrorChecked || '',
            }}
            style={{ padding: 10 }}
          />
        }
        onClose={() => {
          setIsShowModalChecked(false)
          //            location.reload()
        }}
      />
    </div>
  )
}
